import { AdminPageContent } from "@/components/admin";
import { useBreadcrumb } from "@/contexts/shared/breadcrumb";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { useMountEffect } from "@react-hookz/web";
import { FeedbackTable } from "./components/FeedbackTable";

const AdminFeedback = () => {
    const { setBreadcrumbs } = useBreadcrumb();

    useDocumentTitle("Feedback");

    useMountEffect(() => {
        setBreadcrumbs([
            { label: "Admin", path: "home" },
            { label: "Feedback" },
        ]);
    });

    return (
        <AdminPageContent>
            <FeedbackTable />
        </AdminPageContent>
    );
};

export default AdminFeedback;
